import { render } from "./Page.vue?vue&type=template&id=3642fe45&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=3642fe45&scoped=true&lang=css"

import exportComponent from "/home/yazgaroth/code/guinze/guinze.v3/www/grand-place-des-guinzes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3642fe45"]])

export default __exports__